<template>
  <ParagraphBody
    v-if="endOfServiceDate"
    :class="[
      $style.label,
      getServicTagStyle
    ]"
    :weight="paragraphWeight"
  >
    {{ endOfServiceDate }}
  </ParagraphBody>
</template>

<script>
import { DeviceSupportedOSLabels } from 'client/util/Constants';
import {
  ParagraphBody,
} from '@jumpcloud/ui-components';
import { mapState } from 'vuex';
import OsManagementMixin from 'client/OsManagement/mixins/OsManagementMixin';
import moment from 'moment';

const { windows, macos, linux } = DeviceSupportedOSLabels;

export default {
  name: 'EndOfServiceLabel',

  components: {
    ParagraphBody,
  },

  mixins: [OsManagementMixin],

  props: {
    item: {
      default: () => ({}),
      type: Object,
    },
  },

  computed: {
    ...mapState('OsReleasesPatchesModule', ['osVersionPatchList']),

    endOfServiceData() {
      let os = linux;

      if (this.item.name.includes(macos)) {
        os = macos;
      } else if (this.item.name.includes(windows)) {
        os = windows;
      }

      return this.getEndOfServiceDate(os, this.item.fullVersion);
    },

    endOfServiceDate() {
      return this.endOfServiceData.endOfService !== '' ? moment(new Date(this.endOfServiceData.endOfService)).format('MM-DD-YYYY') : '';
    },

    endOfServiceType() {
      const { fullVersion } = this.item;
      const osVersionParts = fullVersion.split(';');
      let styleClass = '';
      const WindowsMajor = osVersionParts[2];
      const WindowsMinor = osVersionParts[3];
      const buildNumber = String(WindowsMajor).split('.')[2];
      // eslint-disable-next-line
      styleClass = this.osVersionPatchList?.Windows?.some((releaseOs) => releaseOs.version+"."+releaseOs.build === buildNumber+"."+WindowsMinor) ? 'latest' : '';

      if (styleClass === '') {
        const { days } = this.getEndOfServiceDate(windows, this.item.fullVersion);

        if (days >= -90 && days <= 0) {
          styleClass = 'nearEndOfService';
        } else if (days > 0) {
          styleClass = 'endOfService';
        }
      }

      return styleClass;
    },

    getServicTagStyle() {
      let style = '';
      if (this.endOfServiceType === 'nearEndOfService') {
        style = this.$style.nearEndOfService;
      } else if (this.endOfServiceType === 'endOfService') {
        style = this.$style.endOfService;
      }
      return style;
    },

    paragraphWeight() {
      return this.endOfServiceType.length > 0 ? 'semibold' : 'normal';
    },
  },

};
</script>
<style module scoped>
.label {
  display: inline-block;
  margin: 0;
  text-align: center;
}

.nearEndOfService {
  color: var(--jcWarning);
}

.endOfService {
  color: var(--jcError);
}

</style>
